import React from 'react'

function Icon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="18" height="18" rx="9" fill="#22C55E" />
      <path
        d="M13.1919 5.80859C13.436 6.05273 13.436 6.44922 13.1919 6.69336L8.19189 11.6934C7.94775 11.9375 7.55127 11.9375 7.30713 11.6934L4.80713 9.19336C4.56299 8.94922 4.56299 8.55273 4.80713 8.30859C5.05127 8.06445 5.44775 8.06445 5.69189 8.30859L7.75049 10.3652L12.3091 5.80859C12.5532 5.56445 12.9497 5.56445 13.1938 5.80859H13.1919Z"
        fill="white"
      />
    </svg>
  )
}

export default Icon
